export default "__VITE_ASSET__BpocqKM$__"